const initialState = {
  events: [
    {
    category: "education",
    day: "April 10",
    description: "Javascript conferrence, biggest community in Scandinavia",
    host: "IT Ninja",
    hour: "10:30 AM",
    localization: "Oslo",
    title: "Javascript conference"
    },
    {
      category: "food&drink",
      day: "March 30",
      description: "Biggest druid market in Europe",
      host: "IT Ninja",
      hour: "13:21 AM",
      localization: "Sevilla",
      title: "Food market in Sevilla"
    },
    {
      category: "music",
      day: "May 3",
      description: "Classic music event",
      host: "Budapest Philharmonic Orchestra",
      hour: "11:15 PM",
      localization: "Budapest",
      title: "Classic music concert"
    },
  ],
  event: {
    category: "test"
  }
}

export default initialState;


// WEBPACK FOOTER //
// ./src/reducers/initialState.js